module.exports = __webpack_public_path__ + "img/84.fb28fcb6.jpg";